import { api } from '../config/api'

const baseEndpoint = '/krea/Resource'

export const createResource = (locale) => api.post(baseEndpoint, { ignoreLocale: true }, { params: { locale } })

export const getResource = ({ id, locale }) => api.get(`${baseEndpoint}/${id}`, { params: { locale } })

export const editResource = ({ id, locale, data }) => api.put(`${baseEndpoint}/${id}`, { ...data, ignoreLocale: true }, { params: { locale } })

export const deleteResource = ({ id, locale }) => api.delete(`${baseEndpoint}/${id}`, { params: { locale } })

export const addLanguageResource = ({ id, locale }) =>
  api.post(`${baseEndpoint}/${id}/LocalizedResource`, { ignoreLocale: true }, { params: { locale } })
